import { Module, VuexModule } from 'vuex-module-decorators'

@Module(
  {
    name: 'Data'
  }
)
export default class Data extends VuexModule {
  // #region Static Data

    vehicles = [
      { label: 'Car', value: 40 },
      { label: 'Van', value: 41 },
      { label: 'Bike', value: 42 }
    ];

    maritalStatuses = [
      { label: 'Married', value: 23 },
      { label: 'Single', value: 24 },
      { label: 'Cohabiting', value: 25 },
      { label: 'Divorced', value: 26 },
      { label: 'Separated', value: 28 },
      { label: 'Widowed', value: 29 },
      { label: 'Civil partnership', value: 30 }
    ];

    titles = [
      { label: 'Mr', value: 1 },
      { label: 'Mrs', value: 2 },
      { label: 'Miss', value: 4 },
      { label: 'Ms', value: 3 }
    ]

    drivingLicenses = [
      { label: 'UK Full Licence', value: 35 },
      { label: 'Provisional UK', value: 36 },
      { label: 'EU', value: 37 },
      { label: 'International', value: 39 },
      { label: 'None', value: 38 }
    ]

    employmentStatuses = [
      { label: 'Full-time', value: 9 },
      { label: 'Part-time', value: 11 },
      { label: 'Self-employed', value: 10 },
      { label: 'Disability', value: 12 },
      { label: 'Retired', value: 13 },
      { label: 'Sub-contractor', value: 14 },
      { label: 'Agency worker', value: 15 },
      { label: 'Homemaker', value: 16 },
      { label: 'Not employed', value: 17 },
      { label: 'Armed forces', value: 18 },
      { label: 'Student', value: 19 },
      { label: 'Family carer', value: 21 }
    ]

    tenancyTypes = [
      { label: 'Private tenant', value: 31 },
      { label: 'Home owner', value: 32 },
      { label: 'Council tenant', value: 33 },
      { label: 'Living with parents', value: 34 }
    ]

  // #endregion
}
